var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3914,
    cy: 13,
    r: 12.6087,
    fill: "#F3F8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_1583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6488 7.59644C10.522 7.59644 7.98779 10.1306 7.98779 13.2575C7.98779 16.3843 10.522 18.9185 13.6488 18.9185C16.7757 18.9185 19.3099 16.3843 19.3099 13.2575C19.3099 10.1306 16.7757 7.59644 13.6488 7.59644ZM12.0655 15.6258H10.9621V12.0943H12.0655V15.6258ZM11.4839 11.652H11.4751C11.0748 11.652 10.8161 11.3823 10.8161 11.0395C10.8161 10.6901 11.0837 10.427 11.4906 10.427C11.8975 10.427 12.1473 10.6901 12.1562 11.0395C12.1584 11.38 11.8997 11.652 11.4839 11.652ZM16.4794 15.6258H15.2277V13.7993C15.2277 13.3216 15.0331 12.9943 14.6019 12.9943C14.2724 12.9943 14.0889 13.2155 14.0049 13.4278C13.9739 13.5029 13.9783 13.6091 13.9783 13.7174V15.6258H12.7378C12.7378 15.6258 12.7532 12.3884 12.7378 12.0943H13.9783V12.6494C14.0513 12.4061 14.4471 12.0611 15.0796 12.0611C15.8646 12.0611 16.4794 12.5698 16.4794 13.6622V15.6258Z",
    fill: "#064A72"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_1583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.3221,
    height: 11.3221,
    fill: "white",
    transform: "translate(7.98779 7.59644)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup28);
export default __webpack_public_path__ + "static/media/Group 28.ea62dcbbe8ac6d57bf927f7e0e59abca.svg";
export { ForwardRef as ReactComponent };